
import {Component, Vue} from "vue-property-decorator";
import {dictApi, mechanismApi, ssoApi, userApi} from "@/api/organization";
import {mapMutations} from "vuex";
import {TagsViewModule} from "@/store/modules/tagsView";
import BangDingOrg from "@/views/pages/component/bang-ding-org.vue";
import router from "@/router";
import {ref} from "vue";
@Component({
  name: "Authorize_sj",
  components: {BangDingOrg},
  methods:{...mapMutations(["changeLogin", "changeUserRight", "saveRegion"])}
})
export default class AuthorizeSJ extends Vue {
  title = "市检局Oauth2认证回调地址";
  bindSuccess = {
    visible: false,
    orgName: ''
  }
  mounted() {
    this.authorize();
  }
  authorize(){
    const loading = this.$loading({
      text: '正在认证,请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    const {code, returnUrl, t}  = this.$route.query as any;
    if(!t){
      window.location.href = window.location.href.replace("jlyw","jdxt");
      return;
    }
    ssoApi.authorize(code, t ? 'v2' : 'v1').then((r: any) => {
      if(r.data.result === 0){
        const rd = r.data.data;
        const { userDetail } = rd;
        const _this = this as any;
        _this.changeLogin(rd)
        this.listUserRights("0");

        if(userDetail.type === 3){
          //未绑定单位
          if(userDetail.organizationId === ''){
            loading.close();
            this.bindSuccess.visible = false;
            const bangDingOrgRef = this.$refs.bangDingOrgRef as any;
            bangDingOrgRef.openDialog();
          }else{ // 绑定单位了但还没有审核。
            this.bindSuccess.visible = true;
            this.bindSuccess.orgName = userDetail.organizationName;
          }
        }else{
          if(t){
            this.$router.replace(returnUrl ? returnUrl : '/list');
          }else{
            window.location.href = "https://jd.hebjlzy.com/#/?redirect=/detect/console&relogin=true";
          }
        }
      } else {
        this.$message.error(r.message);
      }
    }).finally(() => {
      loading.close();
    });
  }

  listUserRights(pageType: string){
    TagsViewModule.delAllViews();
    TagsViewModule.delAllCachedViews();
    userApi.listUserRights(pageType).then(r => {
      if(r.data.result == 0){
        const rData = r.data.data;
        const _this = this as any;
        _this.changeUserRight(rData)
        // this.$router.push("/list");
      }
    })
  }
  onSuccess(orgName: string){
    this.bindSuccess.visible = true;
    this.bindSuccess.orgName = orgName;
  }
}
